<template>
    <div class="communication-section">
        <div class="check-grid">
            <v-checkbox
                v-for="field in communicationsList"
                :key="field.value"
                :label="field.text"
                :input-value="communicationMethods.includes(field.value)"
                color="secondary"
                hide-details
                readonly>
            </v-checkbox>
        </div>
        <div class="graph-wrapper">
            <div class="py-3 d-flex justify-center">
                <label>Face-to-Face Meeting Frequency</label>
            </div>
            <CommunicationGraph
                :meetingsAtPrimaryOffice="meetingsAtPrimaryOffice"
                :meetingsAtSecondaryOffice="meetingsAtSecondaryOffice"
                :meetingsAtClientHome="meetingsAtClientHome"
                :meetingsAtClientOffice="meetingsAtClientOffice"
            />

            <div class="info-item-group list d-flex">
                <v-icon size="46" class="align-self-start mx-n1 mt-2" color="white">mdi-map-marker</v-icon>
                <div class="align-start">
                    <div class="d-block justify-start mb-1"><label>Meetings:</label></div>
                    <template v-for="frq in (meetingFrequency || '').split(';')">
                        <span :key="frq" class="d-block" v-html="frq"></span>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CommunicationGraph from './CommunicationGraph'

export default {
    name: 'OtherDetailsCommunication',
    
    components: {
        CommunicationGraph,
    },

    props: {
        communicationMethods: {
            type: Array,
            default: []
        },
        meetingsAtPrimaryOffice: {
            type: String,
            default: '0',
        },
        meetingFrequency: {
            type: String,
            default: '',
        },
        meetingsAtSecondaryOffice: {
            type: String,
            default: '0',
        },
        meetingsAtClientHome: {
            type: String,
            default: '0',
        },
        meetingsAtClientOffice: {
            type: String,
            default: '0',
        },
        communicationsList: {
            type: Array,
            default: []
        }
    }
}
</script>

<style scoped>
.communication-section {
    display: grid;
    grid-template-columns: 1fr 360px;
    background-color: #EFEFEF;
}

.check-grid {
    margin: 20px 0;
    display: grid;
    grid-template-columns: auto auto;
    grid-gap: 15px 10px;
}

.graph-wrapper {
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 3;

    background-color: #97C13133;
    margin-top: 20px;
    /* padding: 13px 28px 28px; */
    padding: 0;
}

.other-display {
    grid-column-start: 1;
    grid-column-end: 3;
}

.other-display label {
    margin-left: 48px;
}

.communication-section >>> .v-input {
    margin: 0;
}

.communication-section >>> .v-input .v-input--selection-controls__input {
    width: 32px;
    margin-right: 15px;
}

.communication-section >>> .v-input .v-input--selection-controls__input .v-icon {
    color: #5F6062 !important;
    font-size: 32px;
}

.communication-section >>> .v-input--is-label-active .v-input--selection-controls__input .v-icon {
    color: #97C131 !important;
}

.communication-section >>> .v-label,
label {
    color: #5F6062;
    font-size: 16px;
    font-family: "SansationBold", sans-serif;
}

.info-item-group {
    grid-gap: 0 10px !important;
    padding: 10px;
    background-color: #97C131 !important;
}

.info-item-group label,
.info-item-group span {
    color: white !important;
    font-size: 16px !important;
}

.info-item-group span {
    font-family: "Sansation", sans-serif !important;
}
</style>


// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/section-other/Communication.vue